import { Navigate, Outlet, useLocation } from 'react-router';
import { Skeleton } from '@repo-manager/ui';

import { useSession } from '../lib/supabase-context';

/**
 * Gate: render children only if the session is `authed`. While `loading`
 * show a skeleton (avoids a login-flash on warm reloads). When `unauthed`
 * redirect to /login with a `?next=` so we can bounce back post-login.
 */
export function ProtectedLayout() {
  const { status } = useSession();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="space-y-4">
        <Skeleton className="h-10 w-1/3" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
    );
  }
  if (status === 'unauthed') {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <Outlet />;
}
